export default __webpack_public_path__ + "static/media/monitor.7ca0d7d3.png";